<template>
  <el-dialog :visible.sync="showCertGetModal" class="member-cert-get" :close-on-click-modal="false">
    <div
      v-for="(cert, index) in certs"
      :key="index"
      class="member-cert-get_back"
      :class="{ 'member-cert-get_animation': index == certIndex }"
    >
      <div class="member-cert-get_name">{{ cert.cert_name }}</div>
      <div class="member-cert-get_img-wrap">
        <img class="member-cert-get_img" :src="cert.cert_url" />
      </div>
      <router-link class="member-cert-link" :to="{ name: 'MemberCert' }"> 我的证书 </router-link>
      <img class="member-cert-get_close" src="@/assets/images/cert/close@2x.png" @click="onClose" />
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'MemberCertGet',
  data() {
    return {
      showCertGetModal: false,
      certs: [],
      certIndex: 0,
    };
  },
  methods: {
    show(certs) {
      this.certs = certs;
      this.certIndex = 0;
      this.showCertGetModal = true;
    },
    async onClose() {
      if (this.certIndex == this.certs.length - 1) {
        this.showCertGetModal = false;
      } else {
        this.certIndex++;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.member-cert-get {
  ::v-deep {
    .el-dialog {
      width: 851px;
      height: 694px;
      text-align: center;
      background: transparent;
      box-shadow: none;
      margin-top: 0 !important;
      top: 50%;
      transform: translateY(-50%);
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
@keyframes get {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.member-cert-get_back {
  width: 100%;
  height: 100%;
  background: url(~@/assets/images/cert/get@2x.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding-top: 194px;
  transform: scale(0);
  position: absolute;
}
.member-cert-get_animation {
  animation: get 0.5s;
  animation-fill-mode: forwards;
}
.member-cert-get_close {
  width: 32px;
  position: absolute;
  top: 40px;
  right: 161px;
  cursor: pointer;
}
.member-cert-get_name {
  width: 400px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 25px;
}
.member-cert-get_img-wrap {
  width: 360px;
  height: 304px;
  margin: 23px auto;
}
.member-cert-get_img {
  max-width: 100%;
  max-height: 100%;
}
.member-cert-link {
  font-size: 15px;
  color: $primary-color;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    box-sizing: border-box;
    border: 1px solid $primary-color;
    border-left: transparent;
    border-bottom: transparent;
    transform: rotate(45deg) translateY(-75%);
    top: 50%;
  }
}
</style>
